import { useMemo } from 'react';
import io from 'socket.io-client';

export const useSocket = (host) => {

    const socket = useMemo(() => io.connect(host, {
        transports: ['websocket']
    }), [ host ]);
    
    return {
        socket
    }
}